<template>
  <modal
    :exibir="exibir"
    :titulo="tituloModal"
    :campos="$refs"
    id="modalNotas"
    tamanho="xl"
    :ocultarRodape="true"
    @fechar="fecharModal"
  >
    <div v-if="tabelaAvaliacoes">
      <p>
        Para registrar uma nota, é necessário selecionar uma avaliação na tabela
        abaixo,
        <b>clicando no botão na coluna Ações</b> e selecionando a opção
        <b>Registrar nota</b>.
      </p>
      <p>
        Caso não exista a avaliação que queira registrar nota, você pode criar
        uma aula por aqui mesmo clicando no botão abaixo:
      </p>

      <b-button variant="primary" class="mb-5" @click="criarAvaliacao">
        Nova avaliação
      </b-button>

      <tabela-avaliacoes
        :items="tabelas.dados.avaliacoes"
        v-if="tabelaAvaliacoes"
        @avaliacoes="editarNotasAvaliacao"
        @atualizar="getAvaliacoes"
      />
    </div>

    <div v-if="novaAvaliacao">
      <div class="row my-4">
        <div class="col-12 col-md-4">
          <input-date-only-btn
            ref="dataAvaliacao"
            v-model="form.dataAvaliacao"
            :label="$t('GERAL.DATA')"
            required
          />
        </div>
        <div class="col-12 col-md-4">
          <input-select-search
            ref="tipoAvaliacao"
            v-model="form.tipoAvaliacaoId"
            :label="$t(`GERAL.TIPO`)"
            :options="opcoes.tipos"
            required
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            ref="descricao"
            v-model="form.descricao"
            type="text"
            :label="$t('GERAL.DESCRICAO')"
            :placeholder="$t('GERAL.DESCRICAO')"
            required
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            ref="conteudoProgramatico"
            v-model="form.conteudoProgramatico"
            type="text"
            :label="$t('GERAL.CONTEUDO')"
            :placeholder="$t('GERAL.CONTEUDO')"
          />
        </div>
      </div>
    </div>
    <div v-if="tabelaNotas">
      <tabela-nota
        :items="tabelas.dados.notas"
        @atualizado="getNotas"
        :tipoAvaliacaoCodigo="tipoAvaliacaoCodigo"
      />
      <div class="w-100 d-flex justify-content-between">
        <b-button @click="voltarAvaliacoes" variant="secondary" class="mr-2">
          {{ $t('GERAL.VOLTAR') }}
        </b-button>
        <b-button @click="salvarAtualizar" variant="primary" class="mr-2">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </div>
  </modal>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Services & Models:
import AvaliacoesService from '@/common/services/academico/avaliacoes.service.js';
import NotaService from '@/common/services/academico/nota.service.js';
import TipoAvaliacaoService from '@/common/services/academico/tipoAvaliacao.service.js';
import helpers from '@/common/utils/helpers';
// Components:
import Modal from '@/components/modal/Modal.vue';
import TabelaAvaliacoes from './TabelaAvaliacoes.vue';
import TabelaNota from './TabelaNota.vue';
import {
  InputText,
  InputSelectSearch,
  InputDateOnlyBtn,
} from '@/components/inputs';
// import NovaAvaliacao from './NovaAvaliacao.vue';
export default {
  props: {
    exibir: { type: Boolean, default: false },
    formDados: { type: Object, default: Object },
    filtro: { type: Object, default: Object },
  },
  components: {
    Modal,
    TabelaAvaliacoes,
    TabelaNota,
    InputText,
    InputSelectSearch,
    InputDateOnlyBtn,
    // NovaAvaliacao,
  },
  data() {
    return {
      form: {},
      opcoes: {
        tipos: [],
      },
      tabelas: {
        exibir: {
          avaliacoes: true,
          notas: false,
        },
        dados: {
          avaliacoes: [],
          notas: [],
        },
      },
      novaAvaliacao: false,
      dadosNotas: [],
      tipoAvaliacaoCodigo: 0,
    };
  },
  watch: {
    formDados() {
      this.form = JSON.parse(JSON.stringify(this.formDados));
    },
    exibir() {
      this.exibir ? this.configuracaoInicial() : {};
    },
  },
  computed: {
    tabelaAvaliacoes() {
      return this.tabelas.exibir.avaliacoes;
    },
    tabelaNotas() {
      return this.tabelas.exibir.notas;
    },
    tituloModal() {
      return this.form.disciplinaDescricao
        ? `${this.$t('PAINEL_PROFESSOR.NOTAS')} - ${this.$t(
            'PAINEL_PROFESSOR.MATERIA'
          )} ${this.form.disciplinaDescricao} -  ${this.form.turmaDescricao}`
        : `${this.$t('PAINEL_PROFESSOR.NOTAS')}`;
    },
  },
  mounted() {},
  methods: {
    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },
    obterNotas(item = {}) {
      let filtro = {
        anoLetivoId: this.filtro.anoLetivoId,
        cursoId: this.form.cursoId,
        turmaId: this.form.turmaId, //antigo - item.turmaId
        disciplinaId: this.form.disciplinaId, //antigo - item.disciplinaId
        avaliacaoId: item?.id ? item.id : null,
      };

      this.$store.dispatch(START_LOADING);
      NotaService.obterPorFiltro(filtro)
        .then(({ data }) => {
          this.tabelas.dados.notas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    editarNotasAvaliacao(keyHide, keyShow, item) {
      this.form.id = item.id;
      this.form.dataAvaliacao = item.dataAvaliacao;
      this.form.tipoAvaliacaoId = item.tipoAvaliacaoId;
      this.form.descricao = item.descricao;
      this.form.conteudoProgramatico = item.conteudoProgramatico;
      this.tipoAvaliacaoCodigo = item.tipoAvaliacao.codigo;
      this.obterNotas(item);

      this.tabelas.exibir.avaliacoes = false;
      this.tabelas.exibir.notas = true;
      this.novaAvaliacao = true;
      // this.openTabela(keyHide, keyShow, item);
    },
    openTabela(keyHide, keyShow, item) {
      this.tabelas.exibir[keyHide] = false;
      this.tabelas.exibir[keyShow] = true;

      item ? this.tabelas.dados[keyShow] : {};
    },
    criarAvaliacao() {
      this.tabelas.exibir.avaliacoes = false;
      this.tabelas.exibir.notas = true;
      this.novaAvaliacao = true;

      this.obterNotas();

      // this.editarNotasAvaliacao('avaliacoes', 'notas', item);
    },
    salvarAtualizar() {
      this.form.notas = [];
      this.form.notas = this.dadosNotas;
      this.salvar();

      // let padraoNuloId = '00000000-0000-0000-0000-000000000000';

      // const criacao = [];
      // const atualizar = [];

      // this.dadosNotas.forEach((item) => {
      //   item.id === padraoNuloId ? criacao.push(item) : atualizar.push(item);
      // });

      // criacao.length ? this.criar(criacao) : {};
      // atualizar.length ? this.atualizar(atualizar) : {};
    },
    salvar() {
      if (!this.validarFiltro()) return;
      this.$store.dispatch(START_LOADING);
      AvaliacoesService.criarComNota(this.form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Dados atualizados com sucesso')
          );

          this.limparDados();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.voltarAvaliacoes();
          //LIMPAR DADOS NOTAS E OS ITENS DA TABELA AO SALVAR E AO SAIR DA MODAL
        });
    },
    limparDados() {
      this.form = {};
      this.form = JSON.parse(JSON.stringify(this.formDados));
    },
    voltarAvaliacoes() {
      this.tabelas.exibir.avaliacoes = true;
      this.tabelas.exibir.notas = false;
      this.novaAvaliacao = false;
      this.tabelas.dados.notas = [];
      this.limparDados();
      this.getAvaliacoes();
    },
    salvarNovaAvaliacao() {
      this.voltarAvaliacoes();
    },
    criar(form) {
      this.$store.dispatch(START_LOADING);
      NotaService.criar(form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Pontos atualizados com sucesso')
          );
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.fecharModal();
        });
    },
    atualizar(form) {
      this.$store.dispatch(START_LOADING);
      NotaService.editar(form)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('Pontos atualizados com sucesso')
          );
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
          this.fecharModal();
        });
    },
    configuracaoInicial() {
      this.tabelas.exibir.avaliacoes = true;
      this.tabelas.exibir.notas = false;
      this.novaAvaliacao = false;
      this.getAvaliacoes();
      this.getTipos();
    },
    getTipos() {
      this.$store.dispatch(START_LOADING);
      TipoAvaliacaoService.obterPorTipoDeMediaDisciplina(
        this.formDados.disciplinaId,
        this.formDados.turmaId,
        this.filtro.anoLetivoId
      )
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.tipos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getNotas(notasAtualizadas) {
      this.dadosNotas = notasAtualizadas;
    },
    getAvaliacoes() {
      this.$store.dispatch(START_LOADING);
      AvaliacoesService.obterPorFiltro(this.formDados)
        .then(({ data }) => {
          this.tabelas.dados.avaliacoes = data.itens;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    fecharModal() {
      this.tabelas.dados.avaliacoes = [];
      this.$emit('fechar');
    },
  },
};
</script>
